import { useGetStreakQuery } from '~/redux/apis/user-api'
import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated } from '~/auth/slices/auth.slice'

export default function useStreak(): { streakDays: number } | undefined {
  const authenticated = useAppSelector(isAuthenticated)

  const { data } = useGetStreakQuery(undefined, { skip: !authenticated })

  return data
}
